<template>
  <div>
    <div class="main-title mt-4 mb-3">SUMMARY</div>
    <v-card style="border-radius:10px;">
      <v-card-text>
        <v-layout justify-center>
          <v-flex xs5>
            <div>
              <span class="title-store">Order reports : Food & Free & Messenger</span>
              <div
                style="color:#898989;"
              >{{search_config.datetime_start}} - {{search_config.datetime_end}}</div>
              <v-divider class="mb-3" />
            </div>
            <table width="100%">
              <tr>
                <td class="text-table">Total orders</td>
                <td
                  class="text-xs-right"
                >{{food_summary.total_orders ? (food_summary.total_orders).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : food_summary.total_orders}}</td>
              </tr>
              <tr>
                <td class="text-table">Food / Free / Messenger</td>
                <td
                  class="text-xs-right"
                >{{food_summary.foodandmessenger.food ? (food_summary.foodandmessenger.food).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : food_summary.foodandmessenger.food }}/{{food_summary.foodandmessenger.freedelivery ? (food_summary.foodandmessenger.freedelivery).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : food_summary.foodandmessenger.freedelivery}}/{{food_summary.foodandmessenger.messenger ? (food_summary.foodandmessenger.messenger).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : food_summary.foodandmessenger.messenger }}</td>
              </tr>
              <tr>
                <td class="text-table">Food : Complete / Cancel</td>
                <td
                  class="text-xs-right"
                >{{food_summary.foodcompletecancel && food_summary.foodcompletecancel.completed ? (food_summary.foodcompletecancel.completed).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : food_summary.foodcompletecancel.completed}}/{{food_summary.foodcompletecancel && food_summary.foodcompletecancel.canceled ? (food_summary.foodcompletecancel.canceled).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : food_summary.foodcompletecancel.canceled}}</td>
              </tr>
              <tr>
                <td class="text-table">Free : Complete / Cancel</td>
                <td
                  class="text-xs-right"
                >{{food_summary.freedeliverycompletecancel && food_summary.freedeliverycompletecancel.completed ? (food_summary.freedeliverycompletecancel.completed).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : food_summary.freedeliverycompletecancel.completed}}/{{food_summary.freedeliverycompletecancel && food_summary.freedeliverycompletecancel.canceled ? (food_summary.freedeliverycompletecancel.canceled).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : food_summary.freedeliverycompletecancel.canceled }}</td>
              </tr>
              <tr>
                <td class="text-table">Messenger : Complete / Cancel</td>
                <td
                  class="text-xs-right"
                >{{food_summary.messengercompletecancel && food_summary.messengercompletecancel.completed ? (food_summary.messengercompletecancel.completed).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : food_summary.messengercompletecancel.completed }}/{{food_summary.messengercompletecancel && food_summary.messengercompletecancel.canceled ? (food_summary.messengercompletecancel.canceled).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):food_summary.messengercompletecancel.canceled }}</td>
              </tr>
            </table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    between_date: {
      type: Object,
      default() {
        return {
          start: null,
          end: null
        };
      }
    }
  },
  computed: {
    ...mapState({
      food_summary: state => state.fetchReportDashboard.food_summary,
      search_config: state => state.fetchReportDashboard.search_config
    })
  }
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.text-table {
  font-weight: bold;
  line-height: 30px;
}
.title-store {
  font-size: 19px;
  font-weight: bold;
}
</style>
